import { render, staticRenderFns } from "./InitialView.vue?vue&type=template&id=739812d2&scoped=true"
import script from "./InitialView.vue?vue&type=script&lang=js"
export * from "./InitialView.vue?vue&type=script&lang=js"
import style0 from "./InitialView.vue?vue&type=style&index=0&id=739812d2&prod&lang=css"
import style1 from "./InitialView.vue?vue&type=style&index=1&id=739812d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739812d2",
  null
  
)

export default component.exports